module.exports = __webpack_public_path__ + "static/media/super_pack_fr_hiver_chien.92f82726.png";